import type { AppliedSettingsModel, AppliedSettingModel } from '@/app/models/timesheetModel'

export const buildSettingLookup = (
  applied: AppliedSettingsModel | null | undefined,
): Map<string, AppliedSettingModel> => {
  const lookup = new Map<string, AppliedSettingModel>()
  if (!applied?.categories) return lookup
  for (const category of applied.categories) {
    for (const setting of category.settings) {
      lookup.set(setting.key, setting)
    }
  }
  return lookup
}

export const formatSettingValue = (
  setting: AppliedSettingModel | undefined,
  t: (key: string) => string,
): string => {
  if (!setting) return '—'
  if (setting.type === 'bool') {
    return setting.value === 'true' ? t('common.yes') : t('common.no')
  }
  if (setting.type?.startsWith('enum:')) {
    const enumName = setting.type.slice('enum:'.length)
    const localized = t(`explain.enum.${enumName}.${setting.value}`)
    if (localized && localized !== `explain.enum.${enumName}.${setting.value}`) {
      return localized
    }
    return setting.value
  }
  if (setting.type === 'timespan') {
    return formatTimeSpan(setting.value)
  }
  return setting.value
}

const formatTimeSpan = (raw: string): string => {
  const match = /^(?:(\d+)\.)?(\d{1,2}):(\d{2}):(\d{2})/.exec(raw)
  if (!match) return raw
  const days = match[1] ? parseInt(match[1], 10) : 0
  const hours = parseInt(match[2], 10) + days * 24
  const minutes = parseInt(match[3], 10)
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
}
